import { Select } from 'antd';
import styled from '@emotion/styled';
import { useConversationReadonlyValue } from 'hooks/business/conversation';
import { useTranslate } from '@tolgee/react';
import { useAdjustSalesStatus } from 'hooks/business/chat/useChatHeader';

type AdjustSalesStatusProps = {
  conversation: Conversation.Conversation;
};

type StatusColor = { borderColor: string; color: string };

const statusColorMap: Record<string, StatusColor> = {
  BEFORE_SALES_STATUS: {
    borderColor: 'rgba(214,232,255,1)',
    color: 'var(--fett-scenario-accent-text)',
  },
  DURING_SALES_STATUS: {
    borderColor: 'rgba(203,242,225,1)',
    color: 'var(--fett-scenario-success-text)',
  },
  AFTER_SALES_STATUS: {
    borderColor: 'rgba(255,214,214,1)',
    color: 'var(--fett-surface-error-text)',
  },
};

export function ClassicAdjustSalesStatus(props: AdjustSalesStatusProps) {
  const { conversation } = props;
  const readonly = useConversationReadonlyValue();
  const { t } = useTranslate();

  const { salesStatus, changeSalesStatus } = useAdjustSalesStatus(conversation);

  const statusColor = salesStatus != null ? statusColorMap[salesStatus] : undefined;
  return (
    <SSContainer statusColor={statusColor}>
      <Select
        disabled={readonly}
        value={salesStatus}
        onChange={changeSalesStatus}
        optionLabelProp="label"
        dropdownMatchSelectWidth={false}
      >
        <Select.Option value="BEFORE_SALES_STATUS" label={t('domain.salesStage.preSales')}>
          {t('domain.salesStage.preSalesBuyer')}
        </Select.Option>
        <Select.Option value="DURING_SALES_STATUS" label={t('domain.salesStage.inSales')}>
          {t('domain.salesStage.inSalesBuyer')}
        </Select.Option>
        <Select.Option value="AFTER_SALES_STATUS" label={t('domain.salesStage.afterSales')}>
          {t('domain.salesStage.afterSalesBuyer')}
        </Select.Option>
      </Select>
    </SSContainer>
  );
}

const SSContainer = styled.div<{ statusColor?: StatusColor }>`
  margin-left: 4px;
  display: flex;
  align-items: center;
  .ant-select-single {
    &.ant-select-focused {
      &:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
        border-color: ${({ statusColor }) => statusColor?.color} !important;
        box-shadow: none !important;
      }
      border-color: ${({ statusColor }) => statusColor?.color} !important;
      box-shadow: none !important;
    }
    .ant-select-selector {
      height: 20px;
      padding: 0 4px;
      &:hover {
        border-color: ${({ statusColor }) => statusColor?.color};
        box-shadow: none !important;
      }
      border-color: ${({ statusColor }) => statusColor?.color};
      box-shadow: none !important;
      .ant-select-selection-item {
        line-height: 18px;
        font-size: 12px;
        height: 18px;
        padding-right: 10px;
        color: ${({ statusColor }) => statusColor?.color};
      }
    }
    .ant-select-arrow {
      font-size: 10px;
      margin-top: -4px;
      right: 4px;
      color: ${({ statusColor }) => statusColor?.color};
    }
  }
`;
